export const fetchAllRecipes = async () => {
  const response = await fetch('/api/recipes');
  const data = await response.json();
  return data.recipes;
};

export const fetchFilters = async () => {
  const response = await fetch('/api/filters');
  return response.json();
};
